import React from 'react';
import styled from 'styled-components';
import Layout from '../../components/Layout';
import Card from '../../components/Card';
import Metric from '../../components/Metric';
import RiskGauge from '../../components/RiskGauge';

const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 600;
  color: #1A2440;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ExportButton = styled.button`
  background-color: #1A2440;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    background-color: #2c3a5a;
  }
`;

const HighlightsList = styled.ul`
  padding-left: 20px;
  margin: 0;
  
  li {
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 1.5;
  }
`;

const BusinessSummary = styled.div`
  font-size: 16px;
  line-height: 1.6;
  color: #495057;
  position: relative;
  
  .edit-icons {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    gap: 10px;
  }
  
  .icon {
    cursor: pointer;
    color: #6c757d;
    
    &:hover {
      color: #1A2440;
    }
  }
`;

const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const OverviewPage: React.FC = () => {
  return (
    <Layout 
      companyName="Sample Company"
      sector="Software"
      location="United States"
    >
      <PageTitle>
        Sample Company
        <ExportButton>
          <span>Export</span> →
        </ExportButton>
      </PageTitle>
      
      <Card title="Investment Highlights" expandable>
        <HighlightsList>
          <li>Market leader in a growing B2B software segment</li>
          <li>Diverse customer base with high retention rates</li>
          <li>Demonstrated revenue growth and profitability</li>
          <li>Experienced management team with industry expertise</li>
        </HighlightsList>
      </Card>
      
      <TwoColumnLayout>
        <div>
          <Card title="Business Summary">
            <BusinessSummary>
              Brief overview of the company and its business model, products, and market position.
              <div className="edit-icons">
                <span className="icon">✏️</span>
                <span className="icon">💬</span>
              </div>
            </BusinessSummary>
          </Card>
          
          <MetricsGrid>
            <Metric label="Revenue" value="$100M" trend="up" />
            <Metric label="EBITDA" value="$25M" trend="up" />
            <Metric label="EBITDA Margin" value="25%" trend="neutral" />
            <Metric label="CAGR" value="15%" trend="up" />
            <Metric label="Customer Retention" value="95%" trend="up" />
            <Metric label="Gross Margin" value="70%" trend="up" />
          </MetricsGrid>
        </div>
        
        <Card title="Risk Scorecard">
          <RiskGauge level="moderate" />
        </Card>
      </TwoColumnLayout>
    </Layout>
  );
};

export default OverviewPage;
